import { library } from "@fortawesome/fontawesome-svg-core"
import {} from "@fortawesome/free-brands-svg-icons"
import {} from "@fortawesome/free-regular-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"

library.add(fas)
